import { Box, Typography, LinearProgress } from '@material-ui/core'
import { FancySwitch } from 'common/atoms/FancySwitch/FancySwitch'
import { FunctionComponent, useRef } from 'react'
import { useTheme } from 'styled-components/macro'
import { Button } from 'common/atoms/Button/Button'
import { ReactComponent as UploadIcon } from 'icons/upload-resume.svg'
import { ReactComponent as PdfIcon } from 'icons/pdf.svg'
import { ReactComponent as PdfFilledIcon } from 'icons/pdf-filled.svg'
import { ReactComponent as DocIcon } from 'icons/doc.svg'
import { ReactComponent as DocFilledIcon } from 'icons/doc-filled.svg'
import { ReactComponent as CloseIcon } from 'icons/close.svg'
import handleLongText from 'common/utils/handleLongText'
import { ConfirmationDialog } from 'components/core/modal'
import { observer } from 'mobx-react'
import { useAddResume } from 'pages/profile/hooks/useAddResume'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { FileSelectBoxContainer, StyledResumeIcon, UploadBox } from 'components/core/modal/JobApplyModal/styles'

interface AddResume2Props {
  setIsContainerVisible: Function
}

export const AddResume2: FunctionComponent<AddResume2Props> = observer(({ setIsContainerVisible }) => {
  const theme = useTheme()
  const {
    uploadedResume,
    uploadedFileName,
    setShowConfirmDeleteResume,
    showConfirmDeleteResume,
    handleDeleteResume,
    handleUpload,
    handleDrop,
    handleDrag,
    handleDragIn,
    showQuestion,
    handleShowResumeChange,
    handleViewResume,
    resumeLoading,
    notify
  } = useAddResume(setIsContainerVisible)
  const { isDevice } = useScreenSizes()
  const addResumeRef = useRef<HTMLInputElement>(null)
  const showIcon = () => {
    if (uploadedResume?.userAnswer.includes('.pdf')) {
      return resumeLoading ? <PdfIcon /> : <PdfFilledIcon />
    }
    if (uploadedResume?.userAnswer.includes('.doc')) {
      return resumeLoading ? <DocIcon /> : <DocFilledIcon />
    }
  }
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box id="resume-not-uploaded">
        {!uploadedResume?.userAnswer && (
          <Box
            width={isDevice ? '19.5rem' : '51.813rem'}
            height={isDevice ? '11.313rem' : '15.313rem'}
            borderRadius="1rem"
            bgcolor={theme.colors.bgPrimary}
            m="0 0.5rem 1rem 0"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            onDrop={e => {
              handleDrop(e, () => handleUpload(e, 'drag'))
            }}
            // @ts-ignore
            onDragOver={handleDrag}
            // @ts-ignore
            onDragEnter={handleDragIn}
            onClick={() => addResumeRef.current?.click()}
          >
            <Box mt="2rem" display="flex" alignItems="center" flexDirection="column">
            <UploadIcon style={{ marginBottom: '0.625rem' }} />
              <Button
                style={{ width: isDevice ? '10.188rem' : '14.688rem', height: isDevice ? '2.5rem' : '3.125rem' }}
                design="secondary"
              >
                <input
                  id="actual-btn"
                  type="file"
                  ref={addResumeRef}
                  onChange={e => handleUpload(e, 'upload')}
                  hidden
                />
                Upload
              </Button>
            </Box>
            <Typography variant="body2" style={{ marginTop: '1rem' }}>
              Supported file types: pdf, doc (5 MB)
            </Typography>
          </Box>
        )}
      </Box>
      <Box id="resume-uploaded">
        {uploadedResume?.userAnswer && (
          <Box
            width={isDevice ? '19.5rem' : '51.813rem'}
            height="15.313rem"
            borderRadius="1rem"
            bgcolor={theme.colors.bgPrimary}
            m="0 0.5rem 1rem 0"
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Box></Box>
            <Box
              width="100%"
              alignSelf="center"
              display="flex"
              flexDirection="column"
              alignItems="center"
              onClick={handleViewResume}
              ml="2rem"
            >
              {showIcon()}
              <Typography
                variant="body2"
                align="center"
                style={{
                  marginTop: '1rem',
                  textDecoration: 'underline',
                  color: resumeLoading ? 'unset' : theme.colors.primary,
                  cursor: 'pointer'
                }}
              >
                {handleLongText({ text: uploadedFileName?.userAnswer })}
              </Typography>
              {resumeLoading && (
                <LinearProgress
                  color="primary"
                  style={{ width: '95%', margin: isDevice ? '1rem 0 0 0.5rem' : '1rem 0 0 2.8rem' }}
                />
              )}
            </Box>
            <CloseIcon
              style={{ margin: '1.5rem 1.5rem 0 0', width: '1.5rem', height: '1.5rem' }}
              onClick={() => setShowConfirmDeleteResume(true)}
            />
          </Box>
        )}
      </Box>
      <Box display="flex" justifyContent="flex-end" flexDirection="row" mr="1rem" alignSelf="flex-end">
        <Typography variant="subtitle2">
          <Box color={theme.colors.accent} mr="1rem">
            Show
          </Box>
        </Typography>
        <FancySwitch
          width="4.75rem"
          height="1.688rem"
          state={showQuestion?.userAnswer === 'true' ? true : false}
          onChange={handleShowResumeChange}
          currentStateLabel={isOn => (
            <>
              {isOn ? (
                <Typography variant="overline">
                  <Box color={theme.colors.accent1}>ON</Box>
                </Typography>
              ) : (
                <Typography variant="overline">
                  <Box color={theme.colors.accent1}>OFF</Box>
                </Typography>
              )}
            </>
          )}
        />
      </Box>
      <ConfirmationDialog
        open={showConfirmDeleteResume}
        onClose={() => setShowConfirmDeleteResume(false)}
        onConfirm={e => {
          setShowConfirmDeleteResume(false)
          handleDeleteResume(e)
        }}
        message="Are you sure you want to remove this document?"
        cancelBtnLabel="Cancel"
        okBtnLabel="Ok"
      />
    </Box>
  )
})

export default AddResume2
